/*
 * @Author:
 * @Description:
 * @Date: 2024-10-08 15:37:03
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/api/aggregate.js
 */
import http from '@/utils/http';
import { initCardPaymentFields } from '@/utils/tools/cardPaymentBasicForm';

export function getOrderInfo(data) {
  data.transactionWebsite =
    window && window.document && window.document.referrer;
  return http.post('/txn/local/checkoutDetail', data);
}

/**
 * 【仅用于聚合收银台页面】获取订单详情信息
 * 对原始getOrderInfo接口的包装，自动处理卡支付字段初始化
 * 注意：此函数仅供聚合收银台页面使用，其他页面请使用getOrderInfo
 * @param {Object} data 请求参数，包含key和country
 * @returns {Promise} 处理后的API响应，data.checkoutModels中的卡支付方式会被initCardPaymentFields处理
 */
export function getOrderInfo_aggregate(data) {
  return getOrderInfo(data).then(res => {
    if (res.respCode === '20000' && res.data) {
      try {
        if (res.data.checkoutModels) {
          res.data.checkoutModels = res.data?.checkoutModels?.map(item => {
            if (item.cardName === 'CARD') {
              return initCardPaymentFields(item);
            } else {
              return item;
            }
          });
        }
      } catch (e) {
        console.error('初始化卡支付字段失败', e);
      }
    }
    return res;
  });
}

export function payment(data) {
  return http.post('/txn/local/confirmPayment', data);
}

export function getPaymentInfo(key) {
  return http.get(`/txn/checkoutBasicInfo?key=${key}`);
}

/**
 * Apple Pay验证
 * @param {*} data
 * @returns
 */
export function applePayValidateMerchant(data) {
  return http.post('/txn/checkApplePay', data);
}
/**
 * Google Pay验证
 * @param {*} data
 * @returns
 */
export function googlePayValidateMerchant(data) {
  return http.post('/txn/checkGooglePay', data);
}
